import { render, staticRenderFns } from "./InfoTrackerDocumentDropoffForm.vue?vue&type=template&id=6b7cbe23"
import script from "./InfoTrackerDocumentDropoffForm.vue?vue&type=script&lang=js"
export * from "./InfoTrackerDocumentDropoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports